"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var NoteIcon = /*#__PURE__*/function (_React$Component) {
  function NoteIcon() {
    _classCallCheck(this, NoteIcon);
    return _callSuper(this, NoteIcon, arguments);
  }
  _inherits(NoteIcon, _React$Component);
  return _createClass(NoteIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "note-icon icon"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 115 114"
      }, this.props.showText && /*#__PURE__*/_react["default"].createElement("path", {
        d: "M85.5,30.5 C88.2614237,30.5 90.5,32.7385763 90.5,35.5 C90.5,38.1887547 88.3776933,40.3818181 85.7168896,40.4953805 L85.5,40.5 L51.5,40.5 C48.7385763,40.5 46.5,38.2614237 46.5,35.5 C46.5,32.8112453 48.6223067,30.6181819 51.2831104,30.5046195 L51.5,30.5 L85.5,30.5 Z",
        id: "Line",
        fill: "#000"
      }), this.props.showText && /*#__PURE__*/_react["default"].createElement("path", {
        d: "M72.5,51.5 C75.2614237,51.5 77.5,53.7385763 77.5,56.5 C77.5,59.1887547 75.3776933,61.3818181 72.7168896,61.4953805 L72.5,61.5 L51.5,61.5 C48.7385763,61.5 46.5,59.2614237 46.5,56.5 C46.5,53.8112453 48.6223067,51.6181819 51.2831104,51.5046195 L51.5,51.5 L72.5,51.5 Z",
        id: "Line",
        fill: "#000"
      }), this.props.showText && /*#__PURE__*/_react["default"].createElement("path", {
        d: "M60.5,72.5 C63.2614237,72.5 65.5,74.7385763 65.5,77.5 C65.5,80.1887547 63.3776933,82.3818181 60.7168896,82.4953805 L60.5,82.5 L52.5,82.5 C49.7385763,82.5 47.5,80.2614237 47.5,77.5 C47.5,74.8112453 49.6223067,72.6181819 52.2831104,72.5046195 L52.5,72.5 L60.5,72.5 Z",
        id: "Line",
        fill: "#000"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        stroke: "#000",
        fill: "none"
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        strokeWidth: "9",
        x: "17.5",
        y: "4.5",
        width: "93",
        height: "105",
        rx: "14"
      }), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(0 26)",
        fill: "#FFF",
        strokeWidth: "8"
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "4",
        y: "4",
        width: "28",
        height: "16",
        rx: "8"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "4",
        y: "41",
        width: "28",
        height: "16",
        rx: "8"
      })))));
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = (0, _icon_wrapper["default"])(NoteIcon);